import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  font-size: 16px;
  font-family: ${({ theme }) => theme.font.primaryFont};
  color: var(--way-colors-primaryText);
`;

const Highlight = styled.span<{ color?: string }>`
  color: ${({ color }) => color || '#C31843'};
`;

const Prefix = styled.span`
  color: var(--way-colors-contrastColorShades-80);
`;

interface LimitedTimeMessageProps {
  readonly label: string;
  readonly highlightPart?: string;
  readonly highlightColor?: string;
}

const LimitedTimeMessage: React.FC<LimitedTimeMessageProps> = ({
  label,
  highlightPart,
  highlightColor,
}) => {
  if (!highlightPart || !label.includes(highlightPart)) {
    return (
      <Container>
        <Highlight color={highlightColor}>{label}</Highlight>
      </Container>
    );
  }

  const [prefix, ...rest] = label.split(highlightPart);

  return (
    <Container>
      <Prefix>{prefix}</Prefix>
      <Highlight color={highlightColor}>{highlightPart}</Highlight>
      {rest.join('')}
    </Container>
  );
};

export default LimitedTimeMessage;
